import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LaboratoireValidationService {

    constructor() {
    }

    public laboRefExist(laboratoire): boolean {
        return (laboratoire && laboratoire['laboratoireReference']);
    }

    public laboRefIsNotFr(laboRef): boolean {

        if (laboRef && laboRef['adresse'] && laboRef['adresse']['pays']) {
            const pays = laboRef['adresse']['pays'];


            if (typeof pays === 'string' && pays != '/api/countries/FR') {
                return true;
            }
            if (typeof pays === 'object' && pays['@id'] != '/api/countries/FR') {
                return true;
            }
            return false;
        }
        else {
            return true;
        }
    }

    public adresseIsValid(adr): boolean {
        return (
            adr &&
            adr['ville'] &&
            adr['ville'].length &&
            adr['pays'] &&
            adr['pays'] != '' &&
            adr['codePostal'] &&
            adr['codePostal'].length &&
            adr['numEtVoie'] &&
            adr['numEtVoie'].length
        );
    }

    public personneIsValid(personne): boolean {
        return (
            personne['civilite'] &&
            personne['civilite'].length &&
            personne['nom'] &&
            personne['nom'].length &&
            personne['prenom'] &&
            personne['prenom'].length
        );
    }


    public laboRefIsValid(laboRef, strict = true): boolean {

        if (!laboRef['label'] || !laboRef['label'].length) {
            return false;
        }

        if (laboRef['adresse']) {
            if (!this.adresseIsValid(laboRef['adresse'])) {
                return false;
            }
        } else if (strict) {
            return false;
        }

        if (laboRef['directeur']) {
            if (!this.personneIsValid(laboRef['directeur'])) {
                return false;
            }
        } else if (strict) {
            return false;
        }

        return true;
    }


    public laboBaseIsValid(labo): boolean {
        return (
            labo['nom'] &&
            labo['nom'].length &&
            labo['directeurDivision'] &&
            labo['directeurDivision']['personne'] &&
            this.personneIsValid(labo['directeurDivision']['personne']) &&
            labo['adresse'] &&
            this.adresseIsValid(labo['adresse'])
        );
    }

    public laboBaseIsSauvegardable(labo) {
        // plus aucun champs n'est obligatoire dans le cadre d'une sauvegarde "minimal"
        // @todo : verifier eventuellement la validité de la structure
        return true;
    }

    public laboReferenceIsSauvegardable(laboRef): boolean {
        return this.laboRefIsValid(laboRef, false);
    }

    public isValid(laboratoire): boolean {

        if (this.laboRefExist(laboratoire)) {
            // Si pas Français il nous suffit juste de savoir si le laboratoire de Reference est complet.
            if (this.laboRefIsNotFr(laboratoire.laboratoireReference)) {

                return this.laboRefIsValid(laboratoire.laboratoireReference);
            }
            else {
                // Si Laboratoire en France il faut tester si le laboratoire de base est complet également
                return (
                    this.laboRefIsValid(laboratoire.laboratoireReference) &&
                    this.laboBaseIsValid(laboratoire)
                );
            }
        }
        else {
            return false;
        }
    }


}
